import type { StyleSpecification } from 'maplibre-gl';
import { basemapStyle, GLYPHS_URL, type Basemap } from '@/features/basemap';
import { forecastStyle } from '@/features/forecast';
import { glideStyle } from '@/features/glide';
import { composeStyle } from '@/features/map';
import { stationsStyle } from '@/features/stations';
import { terrainStyle } from '@/features/terrain';
import { trailsStyle } from '@/features/trails';
import type { UnitSystem } from '@/features/units';

/** The map style, bottom to top: basemap & contours, forecast wind, trails, terrain DEM, glide results, weather stations. */
export const createMapStyle = (
  basemap: Basemap,
  units: UnitSystem,
  trails: boolean,
  stations: boolean,
): StyleSpecification =>
  composeStyle(GLYPHS_URL, [
    basemapStyle(basemap, units),
    forecastStyle(),
    trailsStyle(trails),
    terrainStyle(),
    glideStyle(),
    stationsStyle(stations),
  ]);
